<template>
    <div class="blackBg  animated slideInLeft">
        <div class="cardTit">
            <span class="season">{{$store.state.seasonName}}</span>
            <span class="teamName">{{teamName?teamName:'XXX'}}</span>
        </div>
        <div class="cardBg">
            <p class="contTit">Antro</p>
            <div class="teamReport">
                <div class="scroll">
                    <ul class="tabHeader">
                        <li class="itemTitle" v-for="(item,ind) in dataLabelArr">{{item}}</li>
                    </ul>
                    <ul v-for="(item,ind) in dataList">
                        <li>
                            <span class="headImg">
                                <img v-if="item.playerAvatar" :src="item.playerAvatar" alt="">
                            <img v-else src="../assets/img/updateImg/headImg.svg" alt="">
                            </span>
                            <span class="name">{{item.playerName}}</span>
                        </li>
                        <li>{{item.date}}</li>
                        <li>{{item.birthday}}</li>
                        <li>{{item.height}}</li>
                        <li>{{item.weight}}</li>
                        <li>{{item.sittingHeight}}</li>
                        <li>{{item.legLength}}</li>
                    </ul>
                    <p style="line-height: 3vw;font-size: 22px;text-align: center;margin-top: 10vw" v-if="dataList.length==0">暂无数据</p>
                    <div style="clear: both"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bodyBasis",
        computed: {
            teamId() {
                return this.$store.state.teamId;
            }
        },
        data() {
            return {
                teamName: this.$store.state.teamName.split('_')[0],//梯队名称
                seasonId: this.$store.state.seasonId,//赛季id
                dataList: [],//aphv数据
                dataLabelArr: ["姓名", "时间", "出生日期", "身高","体重","坐高","腿长"],
                scrollDomHeight: 0,//滚动距离
                scrollTime: 0,//滚动时间
                time: null,//定时器
            }
        },
        watch: {
            teamId: {
                handler(val, old) {
                    if (val != old) {
                        this.teamName = this.$store.state.teamName.split('_')[0];//梯队名称
                        this.info()
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.info();
        },
        methods: {
            info() {
                let data={
                    teamId:this.$store.state.teamId
                }
                this.$server.physicalTestLabel(data)
                    .then(res=>{
                        this.labelId=res.data.length?res.data[res.data.length-1].id:"";//标签id
                        if(res.data.length) {
                            this.getAntroReportFn();
                        }else {
                            this.dataList = []
                        }
                    })
            },
            getAntroReportFn(){
                let data = {
                    physicalTestId:this.labelId
                }
                this.$server.getAntroReport(data)
                    .then((res) => {
                        this.dataList = res.data;
                        let setTime = setTimeout(() => {
                            const lookEl = document.querySelector('.teamReport');
                            const el = document.querySelector('.scroll');
                            this.scrollDomHeight = el.offsetHeight - lookEl.offsetHeight;
                            console.log(this.scrollDomHeight);
                            if (this.scrollDomHeight > 0) {
                                clearInterval(this.time)
                                this.time = setInterval(this.scroll, 8500);
                            }
                            clearTimeout(setTime)
                        }, 100)
                    })
            },
            //滚动数据
            scroll() {
                const el = document.querySelector('.scroll');
                let style = el.getAttribute('style')
                if (style && style == 'margin-top:' + -(this.scrollDomHeight) + 'px') {
                    el.setAttribute('style', 'margin-top:' + 0 + 'px')
                } else {
                    el.setAttribute('style', 'margin-top:' + -(this.scrollDomHeight) + 'px')
                }
            }
        },
        destroyed() {
            clearInterval(this.time)
        }
    }
</script>

<style scoped lang="less">
    .cardTit {
        background-image: url("../assets/img/updateImg/head_2.png");
        font-size: 30px;
        box-sizing: border-box;
        position: relative;

        .season {
            font-family: PingFangMedium;
            color: #fff;
            display: inline-block;
            position: absolute;
            line-height: 130px;
            left: 2vw;
        }
    }

    .cardBg {
        padding: 2vw;
        font-family: PingFangMedium;
        height: calc(100% - 112px);
        width: 100%;

        .contTit {
            color: #fff;
            font-size: 30px;
            height: 2vw;
            line-height: 2vw;
            margin-bottom: .5vw;
        }

        .teamReport {
            height: calc(100% - 2.5vw);
            overflow-y: auto;
            .scroll{
                transition: all 8s linear;
            }
            ul.tabHeader{
                color: #fff;
                height: 2.5vw;
                line-height: 2.5vw;
                border-top: 1px solid rgba(255, 255, 255, .14);
                background: rgba(216, 216, 216, .1);
                font-size: 22px;
                border-radius: 3px 3px 0 0;
            }
            ul {
                clear: both;
                width: 100%;
                box-sizing: border-box;
                font-size: 18px;
                border-bottom: 1px solid rgba(255, 255, 255, .14);
                height: 2vw;
                line-height: 2vw;
                li {
                    width: calc(100% / 7 );
                    float: left;
                    text-align: center;
                    box-sizing: border-box;
                    border-left: 1px solid rgba(255, 255, 255, .14);
                    &:last-child {
                        border-right: 1px solid rgba(255, 255, 255, .14);
                    }
                    span{
                        float: left;
                    }
                    .headImg {
                        margin-top: .1vw;
                        width: 1.6vw;
                        height: 1.6vw;
                        border-radius: 50%;
                        overflow: hidden;
                        display: inline-block;
                        margin-left: 1vw;
                        margin-right: .5vw;
                        img {
                            width: 100%;
                        }
                    }

                }

            }
        }
    }
</style>
